import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import React from "react";
import { hasItems, takeFirst } from "~/features/app/utils";
import { Wrap } from "~/features/ui/wrap";
import { type Mode } from "~/features/ui/get-theme-style";
type SectionDataAttrs = Record<`data-${string}`, string | undefined>;
export type MediaGridBlockViewProps<TRow> = {
  anchor?: Array<{
    id?: string | null;
    name?: string | null;
  }> | {
    id?: string | null;
    name?: string | null;
  } | null;
  getRowKey?: (row: TRow, index: number) => React.Key;
  hasSolidBackground?: boolean | null;
  hasTopDivider?: boolean | null;
  isHighlighted?: boolean | null;
  mode?: string | null;
  renderRow: (row: TRow, index: number) => React.ReactNode;
  rows?: TRow[] | null;
  sectionProps?: React.ComponentPropsWithoutRef<"section"> & SectionDataAttrs;
  theme?: string | null;
};
export function MediaGridBlockView<TRow>({
  anchor,
  getRowKey,
  hasSolidBackground = false,
  hasTopDivider = true,
  isHighlighted = false,
  mode = "light",
  renderRow,
  rows = [],
  sectionProps,
  theme = "white"
}: MediaGridBlockViewProps<TRow>) {
  const validRows = rows ?? [];
  if (!hasItems(validRows)) {
    return null;
  }
  return <_StyledSection {...sectionProps} data-theme={mode as Mode} id={takeFirst(anchor)?.id || undefined} data-anchor-name={takeFirst(anchor)?.name || undefined} $_css={[hasSolidBackground && {
    "position": "relative",
    "backgroundColor": "var(--bg-primary)",
    "color": "var(--text-primary)"
  }, hasTopDivider && {
    "borderTopWidth": "1px",
    "borderColor": "var(--stroke-primary)"
  }, theme === "grey" && {
    "backgroundColor": "var(--bg-tertiary)"
  }, isHighlighted && {
    "backgroundColor": "var(--white-static)"
  }]}>
      <_StyledWrap>
        <_StyledDiv $_css2={[{
        "width": "100%",
        "padding": "1.6rem",
        "@media (min-width: 1024px)": {
          "paddingLeft": "var(--grid-v3-margin)",
          "paddingRight": "var(--grid-v3-margin)",
          "paddingTop": "var(--grid-v3-gutter)",
          "paddingBottom": "var(--grid-v3-gutter)"
        }
      }, {
        "display": "flex",
        "flexDirection": "column",
        "gap": "var(--spacing-md)"
      }]}>
          {validRows.map((row, idx) => <React.Fragment key={getRowKey?.(row, idx) || idx}>{renderRow(row, idx)}</React.Fragment>)}
        </_StyledDiv>
      </_StyledWrap>
    </_StyledSection>;
}
var _StyledSection = /*#__PURE__*/_styled("section").withConfig({
  componentId: "sc-sf-olfjvm-0"
})`${p => p.$_css}`;
var _StyledWrap = _styled2(Wrap).withConfig({
  componentId: "sc-sf-olfjvm-1"
})({
  "borderWidth": "0px"
});
var _StyledDiv = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "media-grid___StyledDiv",
  componentId: "sc-uod2pw-0"
})(["", ""], p => p.$_css2);